// The dark chrome shared by all three English screens (dashboard, lesson,
// coach), so the two-click path from a card to the microphone never flashes a
// different background or moves the way back out.
//
// `.dark-page` is scoped in index.css — the portfolio at "/" stays light.

import { Link } from "react-router-dom";

export default function CoachShell({ back, title, subtitle, actions, children }) {
  return (
    <div className="dark-page min-h-screen">
      <header className="border-b border-slate-800 px-4 py-4 sm:px-6">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-4">
          <div className="min-w-0">
            {back && (
              <Link
                to={back.to}
                className="text-xs text-slate-500 transition hover:text-sky-400"
              >
                ← {back.label}
              </Link>
            )}
            <h1 className="truncate text-lg font-semibold text-slate-100">{title}</h1>
            {subtitle && (
              <p className="mt-0.5 truncate text-xs text-slate-500">{subtitle}</p>
            )}
          </div>
          {actions && <div className="shrink-0">{actions}</div>}
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-4 py-8 sm:px-6">{children}</main>
    </div>
  );
}
